import React, { useState, useEffect } from "react";
import ToggleButton from "../ui/ToggleButton";
import toast from "react-hot-toast";
import usePut from "../../hooks/put/usePut";

/**
 * A reusable status toggle component for table cells.
 * 
 * @param {Object} props
 * @param {string|number} props.id - The unique identifier of the item.
 * @param {string} props.idKey - The property name for the ID in the update payload.
 * @param {string} [props.statusKey="auto_approval_status"] - The property name for the status in the update payload.
 * @param {boolean} props.initialStatus - The current visibility/toggle status.
 * @param {string} props.url - The API endpoint for the status update.
 * @param {string} props.refreshUrl - The React Query key to invalidate on success.
 */
const StatusCell = ({ id, idKey, statusKey = "auto_approval_status", initialStatus, url, refreshUrl }) => {
  const [show, setShow] = useState(initialStatus);

  const { handleAuth: updateStatusMutation } = usePut({
    url: url,
    refreshUrl: refreshUrl,
    onSuccess: () => {
      toast.success("Status updated successfully");
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message || "Failed to update status");
      setShow((prev) => !prev); // Revert on failure
    },
  });

  const { mutate: updateStatus, isLoading } = updateStatusMutation;

  const handleStatusChange = (checked) => {
    setShow(checked);
    updateStatus({
      [idKey]: id,
      [statusKey]: checked,
    });
  };

  return (
    <div className="flex items-center justify-center">
      <ToggleButton
        isChecked={Boolean(show)}
        onChange={handleStatusChange}
        disabled={isLoading}
        variant="success"
      />
    </div>
  );
};

export default StatusCell;
